export const authorBaseUrl = process.env.NEXT_PUBLIC_AUTHORBASEURL
export const internalLinkPath = process.env.NEXT_PUBLIC_INTERNALLINKPATH
export const publisherBaseUrl = process.env.NEXT_PUBLIC_PUBLISHERBASEURL
export const baseUrl = process.env.NEXT_PUBLIC_BASEURL
export const publicWebsiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL
export const publicApiBaseUrl = process.env.NEXT_PUBLIC_APIBASEURL
export const DOMAIN = process.env.NEXT_PUBLIC_GLOBALCONFENV || ""
export const BV_SCRIPT_URL = process.env.NEXT_PUBLIC_BV_SCRIPT
export const LW_APP_NAME = process.env.NEXT_PUBLIC_LW_APP_NAME
export const SOURCE_ORIGIN = process.env.NEXT_PUBLIC_SOURCE_ORIGIN
export const isANYPersona =
  process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true"
export const INVENTORY_CHANNEL_ID = process.env.NEXT_PUBLIC_INVENTORY_CHANNEL_ID

export const apiBVBaseUrl = process.env.BAZAARVOICE_APIURL
export const apiBVApiKey = process.env.BAZAARVOICE_APIKEY
export const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY
export const PDP_DEFAULT_IMAGE = process.env.PDP_DEFAULT_IMAGE
export const apiBaseUrl = process.env.SERVER_APIBASEURL
export const apimPdpShippingSubscriptionKey =
  process.env.APIM_PDP_SHIPPING_SUBSCRIPTION_KEY
